import { createReducer, on } from '@ngrx/store';
import { initialUserMenuListState } from './userMenuList.state';
import { LoadUserMenuList } from './userMenuList.action';
import { logout } from '../user/user.actions';

export const userMenuListReducer = createReducer(
  initialUserMenuListState,
  on(LoadUserMenuList, (_, { menu }) => menu),
  on(logout, () => [])
);
